export default class PostalCode {
  constructor(data) {
    this.id = data?.id;
    this.localGovCodeJp = data?.localGovCodeJp;
    this.oldPostalCode = data?.oldPostalCode;
    this.postalCode = data?.postalCode;
    this.prefectureKana = data?.prefectureKana;
    this.cityKana = data?.cityKana;
    this.areaKana = data?.areaKana;
    this.prefecture = data?.prefecture;
    this.city = data?.city;
    this.area = data?.area;
    this.twoPostalCodesForArea = data?.twoPostalCodesForArea;
    this.additionalNumberForArea = data?.additionalNumberForArea;
    this.stopNumberForArea = data?.stopNumberForArea;
    this.onePostalCodeForMultiAreas = data?.onePostalCodeForMultiAreas;
    this.changeFlag = data?.changeFlag;
    this.reasonOfChange = data?.reasonOfChange;
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
  }
}
